// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Xknp","savePackageButton":"ClientWallet_savePackageButton__1vKbg"};